// extracted by mini-css-extract-plugin
export var container = "_sp-0";
export var inputWidth = "_sp-1";